import {getFilenameFromHeaders} from '../../utils';
import {API} from '../types';

type Params = {
  _start: number;
  _limit: number;
  _sort: string;
  query?: string;
  searchField?: string;
  payrollPeriods?: string[];
  statuses?: string[];
  centreDistrictGroups?: string[];
  startsAt_gte?: string;
  endsAt_lte?: string;
  jobSkillIds?: number[];
  payrollId?: number;
  export_csv: boolean;
};
interface Response {
  content: string;
  filename: string;
}

export function exportTimesheetsAPI(params: Params): API<Response> {
  const urlParams = {
    ...params,
    ...(params.payrollPeriods && {
      payrollPeriods: params.payrollPeriods.join(','),
    }),
    ...(params.statuses && {statuses: params.statuses.join(',')}),
    ...(params.centreDistrictGroups && {
      centreDistrictGroups: params.centreDistrictGroups.join(','),
    }),
    ...(params.jobSkillIds && {jobSkillIds: params.jobSkillIds.join(',')}),
  };

  return {
    getData: async client => {
      const {headers, data} = await client({
        url: '/timesheets',
        method: 'GET',
        params: urlParams,
      });
      const filename = getFilenameFromHeaders(headers);

      return {
        data: {
          content: data,
          filename,
        },
      };
    },
    getMockData: () => {
      return {content: 'content', filename: 'filename'};
    },
  };
}
